import type {UpdateSupplierFormPayload} from "./update-supplier.schema";

import {updateSupplier} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {supplierKeys, supplierMutationKeys} from "../../../supplier-keys";

import {updateSupplierMapper} from "./update-supplier.mapper";

export function updateSupplierMutationOptions(id: string) {
  return mutationOptions({
    mutationKey: supplierMutationKeys.updateSupplier,
    mutationFn: (payload: UpdateSupplierFormPayload) =>
      updateSupplier(id, updateSupplierMapper.toSdk(payload)),
    onSuccess: async (_data, _payload, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: supplierKeys.detail(id)}),
        client.invalidateQueries({queryKey: supplierKeys.lists()}),
      ]);
    },
  });
}
